export const GLOBALS = BUILD_ENV_VARS
